import { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import Dialog from "../../atoms/dialog";
import { Grid, Box } from "@material-ui/core";
import { marginBottom } from "../../../config/styles";
import { openTransactionSelectorForSimulation, invokeGetService, invokePostService, handleSecSnackBar, setReRender } from "../../../store/global/actions"
import { getDetailsFromUrl } from '../../../services/blueprint'
import { getTestcaseNameFromURL } from '../../../utils/commonUtils';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import JsonTableEditor from "../../atoms/jsonFormEditor/JsonTableEditor";
import LoaderWithProgress from '../../atoms/loader/LoaderWithProgress.js';
import CreateCancel from "../../atoms/buttons/CreateCancel";

const SingleTransactionSelector = ({ onClose, order }) => {
    const { search } = useLocation();
    const dispatch = useDispatch()
    const [transactions, setTransactions] = useState([])
    const [loading, setLoading] = useState(true)
    const { blueprintId, entityId } = getDetailsFromUrl();
    const [formData, setFormData] = useState({});
    const [isUpdating, setIsUpdating] = useState(false)
    const testcaseId = getTestcaseNameFromURL(search)


    /** Generate schema */
    const getSchema = (transactions) => {

        let options = [{ title: 'Select', value: null }]
        if (transactions !== undefined) {
            transactions.forEach(tr => {
                console.log('one in each', tr.name)
                options.push({ title: tr.name, value: tr._id })
            })
        }

        let schema = {
            "type": "object",
            "title": "Select a transaction",
            "properties": {
                "transactionID": {
                    "type": "string",
                    "title": "Select a transaction",
                    "enumSource": [{
                        "source": options,
                        "title": "{{item.title}}",
                        "value": "{{item.value}}"
                    }]
                }
            },
            "required": ["transactionID"],
        }

        console.log('schema', schema)
        return schema

    }

    const [schema, setSchema] = useState(getSchema())


    useEffect(() => {
        initiate()
    }, [])

    /** initiate */
    const initiate = async () => {

        dispatch(invokeGetService('getAllTransaction', {})).then(response => {
            if (response.status) {
                const filteredTransactions = response.data.filter(item => item.type === 7);
                setTransactions(filteredTransactions != undefined ? filteredTransactions : []);
                setSchema(getSchema(filteredTransactions))
            } else {
                console.error(response)
            }
            setLoading(false)
        }).catch(error => {
            console.error(error);
        })

    }


    /** JSON editor basic options */
    let options = {
        form_name_root: "transaction_selector",
        show_errors: "never",
        disable_collapse: true,
        disable_edit_json: true,
        disable_properties: true,
        remove_button_labels: true,
        input_width: '100px',
        disable_array_delete_all_rows: true,
        disable_array_reorder: true,
    }



    const validation = () => {
        return [];
    }

    const onCompletion = () => { }
    const handleClose = () => {
        dispatch(openTransactionSelectorForSimulation(false))
        onClose()
    }

    /** on Save of data */
    const onSave = async () => {

        try {

            setIsUpdating(true)
            let obj = {
                transactionId: formData.transactionID,
                testcaseId,
                order
            }

            dispatch(invokePostService('addSimulationTransaction', obj, [testcaseId])).then(response => {
                if (response.status) {
                    dispatch(handleSecSnackBar({ open: true, message: response.message, seviority: 'success' }))
                } else {
                    dispatch(handleSecSnackBar({ open: true, message: response.message, seviority: 'error' }))
                }
            })

            setIsUpdating(false)
            dispatch(setReRender())
            handleClose()

        } catch (error) {
            console.log('Error while adding transaction', error)
            dispatch(handleSecSnackBar({ open: true, message: 'Error while adding  transaction', seviority: 'error' }))
        }
    }

    const onChangeJsonEditor = (data) => {
        setFormData(data);
    }

    let actions = [
        <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }} >
            <CreateCancel onCreate={onSave} createDisable={loading || isUpdating} onCancel={handleClose} />
        </Grid>
    ]




    return (
        <Dialog
            open={true}
            title={"Add Transaction"}
            actions={actions}
            handleClose={handleClose}
        >
            <Box>

                <Grid xs={12} style={marginBottom}>
                    {loading && <LoaderWithProgress size={20} isContent={true} styleRoot={{ height: '8vh' }} />}

                    {loading == false && <JsonTableEditor
                        options={options}
                        schema={schema}
                        validation={validation}
                        onChangeJsonEditor={onChangeJsonEditor}
                        editorId="json_table_editor"
                    />
                    }
                </Grid>

            </Box>

        </Dialog>
    )
}

export default SingleTransactionSelector;